export const GET_WINNERS_FOR_MAIN_PAGE_REQUEST = 'GET_WINNERS_FOR_MAIN_PAGE_REQUEST';
export const GET_WINNERS_FOR_MAIN_PAGE_SUCCESS = 'GET_WINNERS_FOR_MAIN_PAGE_SUCCESS';
export const GET_WINNERS_FOR_MAIN_PAGE_FAILURE = 'GET_WINNERS_FOR_MAIN_PAGE_FAILURE';

export const GET_ALL_WINNERS_FOR_COMPETITION_REQUEST = 'GET_ALL_WINNERS_FOR_COMPETITION_REQUEST';
export const GET_ALL_WINNERS_FOR_COMPETITION_SUCCESS = 'GET_ALL_WINNERS_FOR_COMPETITION_SUCCESS';
export const GET_ALL_WINNERS_FOR_COMPETITION_FAILURE = 'GET_ALL_WINNERS_FOR_COMPETITION_FAILURE';
